import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { catchError, finalize, of, tap } from 'rxjs';
import { AuthService } from '@anihis/core/data-access';
import { LoadingStatus } from '../../shared/enums/loading';

type RestoreAccountState = {
  status: LoadingStatus;
  error: string | null;
};

const initialState: RestoreAccountState = {
  status: LoadingStatus.Loading,
  error: null,
};

export const RestoreAccountStore = signalStore(
  withState(initialState),
  withMethods((store, authService = inject(AuthService)) => ({
    restoreAccount(userId: string, token: string, rola: string) {
      patchState(store, { status: LoadingStatus.Loading, error: null });

      return authService.authRestoreAccountPost({ userId, token }).pipe(
        tap(() => {
          const scheme =
            rola.toLowerCase() === 'veterinarian'
              ? 'com.anihis.veterinarian.app'
              : 'com.anihis.app';
          window.location.href = `${scheme}://`;
          patchState(store, { status: LoadingStatus.Loaded });
        }),
        catchError((err) => {
          const errorMessage =
            err?.error?.message ||
            err?.error?.title ||
            err?.error ||
            'An error occurred. Please try again.';
          patchState(store, {
            status: LoadingStatus.Error,
            error:
              typeof errorMessage === 'string'
                ? errorMessage
                : JSON.stringify(errorMessage),
          });
          return of(null);
        }),
        finalize(() => {}),
      );
    },
  })),
);
